module.exports = "/_next/static/images/nvp-ac8515ecb245996f4b985783892a057e.png";